module.exports = __webpack_public_path__ + "img/Dash_add.e75efa22.svg";